function downloadFile(blob: Blob, fileName = "download.pdf", fileType = "application/pdf"): void {
    const newBlob = new Blob([blob], { type: fileType });

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (window?.navigator?.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob, fileName);

        return;
    }

    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement("a");

    link.href = data;
    link.download = fileName;
    link.setAttribute("type", "hidden");
    document.body.appendChild(link);
    link.click();
    link.remove();

    setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
    }, 100);
}

export default downloadFile;
